export default (page: any) => {
    return `c${page?._culture}_h${page?._homeNodeId}`;
};